// extracted by mini-css-extract-plugin
export default {"container":"AnnouncementFooter_container__kp5KT","remindLaterButton":"AnnouncementFooter_remindLaterButton__W51rp","nextButton":"AnnouncementFooter_nextButton__DIcI0"};